// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__IIKxB","cardOuter":"Card_cardOuter__Jz8NQ","cardDetails":"Card_cardDetails__L-CDs","cardBody":"Card_cardBody__8qvZU","img":"Card_img__fzIup"};